import { Alert } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"

export function MissingScheduleTypesDialog() {
    return (
        <DialogBox title="Schedule Type Required" Actions={Done} okCaption="Ok" data-cy="missing-schedule-types-dialog">
            <Alert severity="error" sx={{ mt: 1 }}>
                At least one schedule type must be selected before submitting for review.
            </Alert>
        </DialogBox>
    )
}
